import React from 'react';
import { Col, Row } from 'react-bootstrap';

import BasicInfo from './BasicInfo.jsx';
import RaceDetails from './RaceDetails.jsx';
import FieldRatingSelfSubmit from './FieldRatingSelfSubmit.jsx';
import SectionCornerOverall from './SectionCornerOverall.jsx';
import FieldTextArea from './FieldTextArea.jsx';
import FieldTextAreaWithRating from './FieldTextAreaWithRating.jsx';

const overrideOptions = [
  { slug: 1, value: '1 - Poor' },
  { slug: 2, value: '2 - Below Average' },
  { slug: 3, value: '3 - Average' },
  { slug: 4, value: '4 - Above Average' },
  { slug: 5, value: '5 - Exceptional' },
];

export default function Race() {
  return (
    <form id="self-ratings-race-form" autoComplete="off">
      <h3>TRD Driver Self Rating - Race</h3>
      <p className="subtext">All fields marked with an asterisk symbol (*) are mandatory.</p>
      <BasicInfo />
      <RaceDetails />
      <hr />
      <p className="subtext">All information given is confidential and will not be shared with any group outside of TRD.</p>
      <SectionCornerOverall />
      <Row>
        <Col lg={6}>
          <FieldTextAreaWithRating
            label="5) Brakes"
            description="Describe brakes"
            ratingField="brakes.rating"
            textAreaField="brakes.feedback"
            placeholder="Feedback"
            overrideOptions={overrideOptions}
            overrideDefaultValue={5}
          />
        </Col>
        <Col lg={6}>
          <FieldTextAreaWithRating
            label="6) Tire Falloff"
            description="Describe tire falloff"
            ratingField="tireFallOff.rating"
            textAreaField="tireFallOff.feedback"
            placeholder="Feedback"
            overrideOptions={overrideOptions}
            overrideDefaultValue={5}
          />
        </Col>
        <Col lg={6}>
          <FieldTextAreaWithRating
            label="7) Engine"
            ratingField="enginePerformanceRelativeCompetition.rating"
            textAreaField="enginePerformanceRelativeCompetition.feedback"
            placeholder="Feedback"
            description="Describe engine compared to competition"
            overrideOptions={overrideOptions}
            overrideDefaultValue={5}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <FieldTextArea field="additionalComments" placeholder="Additional Comments" />
        </Col>
      </Row>

      <div className="form-submit-wrapper">
        <div className="pull-right">
          <FieldRatingSelfSubmit
            buttonText="Submit and Rate Reflection"
            redirectTo="/rating/self/reflection"
            formType="race"
          />
        </div>
        <div className="pull-right">
          <FieldRatingSelfSubmit formType="race" />
        </div>
      </div>
    </form>
  );
}
